import {
  faBold,
  faItalic,
  faList,
  faListOl,
  faUnderline,
} from '@awesome.me/kit-4a6bf60416/icons/classic/regular';
import { useCurrentEditor, useEditorState } from '@tiptap/react';

import { Icon } from '@/components/ui/icon';
import { Toggle } from '@/components/ui/toggle';

export function TextButtons() {
  const { editor } = useCurrentEditor();

  const editorState = useEditorState({
    editor,
    selector: (ctx) => ({
      isBold: ctx.editor?.isActive('bold') ?? false,
      isItalic: ctx.editor?.isActive('italic') ?? false,
      isUnderline: ctx.editor?.isActive('underline') ?? false,
      isBulletList: ctx.editor?.isActive('bulletList') ?? false,
      isOrderedList: ctx.editor?.isActive('orderedList') ?? false,
    }),
  });

  if (!editor || !editorState) {
    return null;
  }

  const markItems = [
    {
      name: 'bold',
      isActive: editorState.isBold,
      command: () => editor.chain().focus().toggleBold().run(),
      icon: faBold,
    },
    {
      name: 'italic',
      isActive: editorState.isItalic,
      command: () => editor.chain().focus().toggleItalic().run(),
      icon: faItalic,
    },
    {
      name: 'underline',
      isActive: editorState.isUnderline,
      command: () => editor.chain().focus().toggleUnderline().run(),
      icon: faUnderline,
    },
  ];

  const listItems = [
    {
      name: 'bullet list',
      isActive: editorState.isBulletList,
      command: () => editor.chain().focus().toggleBulletList().run(),
      icon: faList,
    },
    {
      name: 'ordered list',
      isActive: editorState.isOrderedList,
      command: () => editor.chain().focus().toggleOrderedList().run(),
      icon: faListOl,
    },
  ];

  return (
    <div className="flex items-center gap-1">
      <div className="flex gap-1">
        {markItems.map((item) => (
          <Toggle
            key={item.name}
            pressed={item.isActive}
            onPressedChange={item.command}
            aria-label={`Toggle ${item.name}`}
          >
            <Icon icon={item.icon} />
          </Toggle>
        ))}
      </div>
      <div className="flex gap-1">
        {listItems.map((item) => (
          <Toggle
            key={item.name}
            pressed={item.isActive}
            onPressedChange={item.command}
            aria-label={`Toggle ${item.name}`}
          >
            <Icon icon={item.icon} />
          </Toggle>
        ))}
      </div>
    </div>
  );
}
